export default {
  // Hero
  'hero.badge': '문의하기',
  'hero.title': '용기 소싱에 대해 이야기해 보세요',
  'hero.subtitle':
    '단품 기성 용기부터 완전 맞춤형 프로그램까지, 소싱 팀이 궁금한 점에 답하고 견적을 안내해 드립니다.',

  // Quick Contact
  'quick.label': '연락처',
  'quick.title': '빠르게 답변드립니다',
  'quick.subtitle':
    '아래 방법으로 직접 연락하시거나, 메시지를 남겨주시면 영업일 기준 1일 이내에 답변드립니다.',
  'quick.email.label': '이메일',
  'quick.email.desc': '문의, 견적, 파트너십 관련',
  'quick.phone.label': '전화',
  'quick.phone.desc': '평일 09:00\u201318:00 (KST / CST)',
  'quick.response.label': '응답 시간',
  'quick.response.value': '영업일 1일 이내',
  'quick.response.desc': '지역별 전담 매니저가 배정됩니다',

  // Locations
  'locations.label': '지사 안내',
  'locations.title': '세 곳의 거점, 하나의 글로벌 네트워크',
  'locations.subtitle':
    '서울 본사와 중국 주요 제조 거점의 지사들을 통해 고객과 공장 모두에 가까이 다가갑니다.',
  'locations.hq.badge': '본사',
  'locations.branch.badge': '지사',
  'locations.hq.name': '서울 \u2014 성수동',
  'locations.hq.address': '대한민국 서울특별시 성동구 성수동',
  'locations.hq.note': '글로벌 소싱 & 고객 성공',
  'locations.b1.badge': '중국 지사 1',
  'locations.b1.name': '상하이 \u2014 민항',
  'locations.b1.address': '중국 상하이시 민항구',
  'locations.b1.note': '동중국 소싱 & 품질관리',
  'locations.b2.badge': '중국 지사 2',
  'locations.b2.name': '광저우 \u2014 바이윈',
  'locations.b2.address': '중국 광저우시 바이윈구',
  'locations.b2.note': '남중국 소싱 & 물류',

  // Form
  'form.label': '메시지 보내기',
  'form.title': '필요한 것을 알려주세요',
  'form.subtitle':
    '양식을 작성해 주시면 가격, 샘플, 또는 다음 단계에 대해 안내해 드립니다.',
  'form.name': '이름',
  'form.name.placeholder': '이름을 입력하세요',
  'form.email': '회사 이메일',
  'form.email.placeholder': 'you@company.com',
  'form.company': '회사명',
  'form.company.placeholder': '회사명을 입력하세요',
  'form.country': '국가 / 지역',
  'form.country.placeholder': '국가를 선택하세요',
  'form.type': '문의 유형',
  'form.type.general': '일반 문의',
  'form.type.quote': '견적 요청',
  'form.type.sample': '샘플 요청',
  'form.type.partnership': '공급업체 파트너십',
  'form.type.other': '기타',
  'form.message': '메시지',
  'form.message.placeholder':
    '원하는 제품, 수량, 후가공, 또는 일정에 대해 알려주세요\u2026',
  'form.submit': '메시지 보내기',
  'form.sending': '전송 중\u2026',
  'form.success.title': '메시지가 전송되었습니다!',
  'form.success.desc':
    '문의해 주셔서 감사합니다. 영업일 기준 1일 이내에 답변드리겠습니다.',
  'form.error.title': '문제가 발생했습니다',
  'form.error.retry': '다시 시도해 주세요.',
};